import axios from "axios";
import { BACKEND_API_URL, FRONTEND_APP_URL } from "../environment";
import store from "../store";

// const BACKEND_API_URL = `${process.env.REACT_APP_API_HOSTNAME}:${process.env.REACT_APP_API_BACKEND_PORT}`;
// const FRONTEND_APP_URL = `${process.env.REACT_APP_API_HOSTNAME}:${process.env.REACT_APP_API_FRONTEND_PORT}`;

export { BACKEND_API_URL, FRONTEND_APP_URL };

const axiosInstance = axios.create({
  baseURL: `${BACKEND_API_URL}`,
  timeout: 30000,
  // headers: {
  //   "Content-Type": "application/json",
  // },
});

// Add a request interceptor to inject tokens or modify requests
axiosInstance.interceptors.request.use(
  (config) => {
    // Try Redux first
    const state = store.getState();
    let token = state?.auth?.auth_info?.token;

    // Fallback to localStorage
    if (!token) {
      token = localStorage.getItem("token");
    }

    // Fallback to sessionStorage
    if (!token) {
      const authInfo = JSON.parse(sessionStorage.getItem("auth_info") || "{}");
      token = authInfo?.token;
    }


    if (token) {
      config.headers["auth-token"] = token.trim();
    }

    return config;
  },
  (error) => Promise.reject(error)
);


// Add a response interceptor for global error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle errors globally
    if (error.response?.status === 401) {
      // localStorage.clear()
        localStorage.removeItem("token");
  localStorage.removeItem("auth_info");
      // Handle session expiration
      sessionStorage.clear();
      // Unauthorized - Maybe redirect to login
      console.error("Unauthorized. Redirecting to login...");
      window.location.href = "/login"

      // Stop further processing (prevents showing "Internal Error")
      return new Promise(() => { }); // Creates a never-resolving promise
    }
    return Promise.reject(error);
  }
);

//old method
export const requestData = async (method, endPoint, data = {}, config = {}) => {
  try {
    let response;
    if (method === "get") {
      response = await axiosInstance.get(endPoint, data);
    } else if (method === "post") {
      if (data instanceof FormData) {
        // ✅ Let axios handle FormData correctly
        response = await axiosInstance.post(endPoint, data, {
          headers: { "Content-Type": "multipart/form-data" },
          ...config, // ✅ support extra options like responseType: "blob"
        });
      } else {
        response = await axiosInstance.post(endPoint, data, config);
      }
    } else if (method === "put") {
      response = await axiosInstance.put(endPoint, data);
    } else if (method === "patch") {
      response = await axiosInstance.patch(endPoint, data);
    } else if (method === "delete") {
      response = await axiosInstance.delete(endPoint, {
        data,
        ...config,
      });
    } else {
      throw new Error("Invalid method");
    }
    return response;
  } catch (err) {
    console.log(err);
    // Extract backend error if available
    let message = "Request failed";

    if (err.response) {
      // Axios response available
      message =
        err.response.data?.message ||
        err.response.data?.error ||
        `HTTP ${err.response.status}: Request failed`;
    } else if (err.message) {
      // Network or other error
      message = err.message;
    }

    console.error("API Error:", err.response || err);
    const error = new Error(message);
    error.response = err.response?.data;
    throw error;
  }
};

export const getBlobData = (url) => axiosInstance.get(url, { responseType: "blob" });
export const fetchData = (endPoint, data) => requestData("get", endPoint, data);
export const postData = (endPoint, data, config = {}) => requestData("post", endPoint, data, config);
export const putData = (endPoint, data) => requestData("put", endPoint, data);
export const patchData = (endPoint, data) => requestData("patch", endPoint, data);
export const deleteData = (endPoint, data) => requestData("delete", endPoint, data);

export default axiosInstance;
